<template>
  <div>
    <v-btn large block outlined color="primary" rounded dark @click="showShareDialog = !showShareDialog">Share this offer</v-btn>

    <v-dialog v-model="showShareDialog" max-width="550" @click:outside="showShareDialog = !showShareDialog">
      <v-card class="rounded-corners">
        <v-card-title class="headline font-weight-bold">Share this offer with friends and family</v-card-title>
        <v-card-text class="text-center">
          <div class="mt-3 mb-10 body-1 font-weight-light" style="color: #222222">Support this business by sharing this offer with your friends and family</div>

          <v-row class="mx-2 mb-3">
            <v-col v-for="(provider, index) in socialProviders" :key="index" class="text-center" @click="handleShare(provider)">
              <v-btn :color="provider.color" fab dark small class="mb-2" style="height: 50px; width: 50px">
                <v-icon style="font-size: 29px">{{ provider.icon }}</v-icon>
              </v-btn>
              <div class="font-weight-light">{{ provider.network }}</div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Vue from 'vue'

import { copyToClipboard } from '@/mixins/copyToClipboard'

export default Vue.extend({
  name: 'ShareOffer',

  mixins: [copyToClipboard],

  props: {
    businessBrand: {
      type: String,
      required: true,
    },
    offerSummary: {
      type: String,
      required: true,
    },
    offerShortUrlId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    showShareDialog: false,
  }),

  computed: {
    socialProviders() {
      return [
        {
          type: 'popup',
          color: '#3A5A99',
          network: 'Facebook',
          icon: 'mdi-facebook',
          sharer: 'https://www.facebook.com/sharer/sharer.php?u=@url',
        },
        {
          type: 'popup',
          color: '#55ACEE',
          network: 'Twitter',
          icon: 'mdi-twitter',
          sharer: 'https://twitter.com/intent/tweet?text=@title&url=@url',
        },
        {
          type: 'direct',
          color: '#25D366',
          network: 'Whatsapp',
          icon: 'mdi-whatsapp',
          sharer: 'https://api.whatsapp.com/send/?phone&text=@title%20@url',
        },
        {
          type: 'direct',
          color: '#C71610',
          network: 'Email',
          icon: 'mdi-email',
          sharer: 'mailto:?subject=@title&body=@url',
        },
        {
          type: 'direct',
          color: '#5EB254',
          network: 'SMS',
          icon: 'mdi-message-processing',
          sharer: 'sms:?body=@title%20@url',
          iosSharer: 'sms:?&body=@title%20@url',
        },
        {
          type: 'clipboard',
          color: '#222222',
          network: 'Copy Link',
          icon: 'mdi-content-copy',
          sharer: '@title @url',
        },
      ]
    },
  },

  methods: {
    handleShare: function (provider) {
      const url = this.createSharingUrl(provider)

      if (provider.type === 'popup') {
        this.displaySharePopup(url)
      } else if (provider.type === 'direct') {
        window.open(url, '_blank')
      } else if (provider.type === 'clipboard') {
        this.copyToClipboard(decodeURIComponent(url))
        this.$toast.success('Copied to clipboard!')
      }
    },
    createSharingUrl: function (provider) {
      const userAgent = navigator.userAgent.toLowerCase()
      const useIosSharer = provider.network === 'SMS' && (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1)
      const sharer = useIosSharer ? provider.iosSharer : provider.sharer

      return sharer
        .replace(/@url/g, encodeURIComponent(`${process.env.VUE_APP_SHORT_URL}${this.offerShortUrlId}`))
        .replace(/@title/g, encodeURIComponent(`Check out this offer from ${this.businessBrand} - ${this.offerSummary}`))
    },
    displaySharePopup: function (url) {
      const sw = screen.availWidth || 1024,
        sh = screen.availHeight || 700,
        pw = Math.min(600, sw - 40),
        ph = Math.min(600, sh - 40),
        px = Math.floor((sw - pw) / 2),
        py = Math.floor((sh - ph) / 2)

      window
        .open(url, 'sharer', `width=${pw},height=${ph},left=${px},top=${py},location=0,menubar=0,toolbar=0,personalbar=0,status=0,scrollbars=1,resizable=1`)
        .focus()
    },
  },
})
</script>

<style scoped>
.rounded-corners {
  border-radius: 16px;
}
</style>
